import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

@Pipe({
  name: 'phoneFormat',
  standalone: false
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string, country: CountryCode = 'US'): string {
    if (!value) return '';

    try {
      const phoneNumber = parsePhoneNumberFromString(value, { defaultCountry: country });
      if (phoneNumber) {
        return `+${phoneNumber.countryCallingCode} ${phoneNumber.formatNational()}`;
      }
    } catch (error) {
      console.warn('Phone parsing error:', error);
    }
    return value;
  }
}
